import { LocalStorage } from './LocalStorage';

export const getCliente = (): any => {
  return LocalStorage.get<any>('cliente');
};
